import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

export const unselectableComponents = [
    // 'LAMP_22_DIA_GREEN',
    // 'LAMP_22_DIA_RED',
    // 'LAMP_22_DIA_AMBER',
    'Solid0370',
    'Shell',
    'SOLID_',
    'TH00104XXXX_1',
    'TH00097XXXX_',
    'C_TJ72435B22F',
    'C_TJ72684XXXX',
    'TH34233P632001',
    'V350-J_MFM',
    'SLANT_HEADER',
    'CM59081',
    'E-PLATE',
    'MESHES',
    'meshes',
    'HANDLE',
    'TOP_PLATE',
    'BRAND',
    'HRD',
    'PLINTH',
    'TRAY'
  ];
export const lightThemeStyles = {
    cardStyle: {
      marginBottom: 0.5,
      border: '1px solid var(--brand-color-1)',
      borderRadius: '2px',
      paddingRight: 1,
      paddingLeft: 1,
      backgroundColor: '#efefef', // Updated for light theme
      color: 'black',
      overflowY: 'auto',
    },
    titleStyle: {
      color: 'black',
      fontSize: '20px',
      fontWeight: '700',
      fontFamily: 'Roboto',
    },
    subtitleStyle: {
      color: 'black',
      fontSize: '16px',
      fontWeight: '500',
      fontFamily: 'Roboto',
    },
    bodyTextStyle: {
      color: 'black',
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: 'Roboto',
    },
  };
  
export const darkThemeStyles = {
    cardStyle: {
      marginBottom: 0.5,
      border: '1px solid var(--brand-color-1)',
      borderRadius: '2px',
      paddingRight: 1,
      paddingLeft: 1,
      backgroundColor: '#000000', // Updated for dark theme
      color: 'var(--primary-text)',
      overflowY: 'auto',
    },
    titleStyle: {
      color: 'var(--highlighted-text-1)',
      fontSize: '20px',
      fontWeight: '700',
      fontFamily: 'Roboto',
    },
    subtitleStyle: {
      color: 'var(--secondary-text)',
      fontSize: '16px',
      fontWeight: '500',
      fontFamily: 'Roboto',
    },
    bodyTextStyle: {
      color: 'var(--primary-text)',
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: 'Roboto',
    },
  };
  // Example data series
export  const temperatureTrendSeries = [
    {
      name: 'HBB R',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 35 },
        { x: new Date('2025-02-19').getTime(), y: 31 },
        { x: new Date('2025-02-20').getTime(), y: 29 },
        { x: new Date('2025-02-21').getTime(), y: 33 },
        { x: new Date('2025-02-22').getTime(), y: 34 },
      ],
    },
    {
      name: 'HBB Y',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 38 },
        { x: new Date('2025-02-19').getTime(), y: 39 },
        { x: new Date('2025-02-20').getTime(), y: 30 },
        { x: new Date('2025-02-21').getTime(), y: 31 },
        { x: new Date('2025-02-22').getTime(), y: 32 },
      ],
    },
    {
      name: 'HBB B',
      data: [
        { x: new Date('2025-02-18').getTime(), y: 26 },
        { x: new Date('2025-02-19').getTime(), y: 27 },
        { x: new Date('2025-02-20').getTime(), y: 28 },
        { x: new Date('2025-02-21').getTime(), y: 29 },
        { x: new Date('2025-02-22').getTime(), y: 30 },
      ],
    },
  ];

export const voltageData = [
  { label: 'L1 ', key: 'rmsVoltage1' },
  { label: 'L2 ', key: 'rmsVoltage2' },
  { label: 'L3 ', key: 'rmsVoltage3' },
  { label: 'Average', key: 'averageVoltage' }
];

export const currentData = [
  { label: 'RMS R', key: 'rmsCurrent1' },
  { label: 'RMS Y', key: 'rmsCurrent2' },
  { label: 'RMS B', key: 'rmsCurrent3' },
  { label: 'THD R Phase Current', key: 'thdRPhaseCurrent' },
  { label: 'THD Y Phase Current', key: 'thdYPhaseCurrent' },
  { label: 'THD B Phase Current', key: 'thdBPhaseCurrent' }
];

export const componentInfoDefaults = [
  { label: 'Motor Voltage', key: 'motorVoltage', defaultValue: '389.40 V' },
  { label: 'DC Link Voltage', key: 'dcLinkVoltage', defaultValue: '400.30 V' },
  { label: 'Current', key: 'current', defaultValue: '0.00 A' },
  { label: 'Power', key: 'power', defaultValue: '0.00 kW' },
  { label: 'Frequency', key: 'frequency', defaultValue: '50.00 Hz' },
  { label: 'Power Factor', key: 'powerFactor', defaultValue: '0.98' }
];

export const initialFormState = {
  // Required Fields
  breaker: "8", // Maps to "8" in API
  current_y: "2500",
  panelHeight: "2.1",
  panelWidth: "0.8",
  panelDepth: "0.8",
  ambient: "32.2",
  
  // Optional Fields with example defaults
  month: "",
  latitude: "",
  panelColor: "",
  panelOrientation: "",
  solarToggle: "",
  solarEnv: "",
  coveredSurfaces: ["Bottom"], // bottom: true, all others false
  linksPerPole: "4",
  linkWidth: "0.1",
  linkThickness: "0.005",
  crossSection: "2000e-6", // 2000e-6
  insulationThickness: "0.0005",
  spreaderThickness: "0",
  upperTempLimit: "100",
  links_total_length: "8.7", // Same as linkLength to avoid mismatch
  numPartitions: "0",
  numBreakers: "1",
  breakerDistribution: "Equally spaced", // Maps to 0 via distributionMap
  topBreakerHeight: "0",
  breakerGap: "0",
  additionalPower: "0",
  breakerPositionTop: "1",
  ventArea: "",
  cfm: "",
  ipRating: "IP5X",
  current_cl: "2500",
  hotResistivity: "2.26e-8", // 2.26e-8
  linkLength: "2.9",
  spreaderUsed: false,
  altitude: "",
  
  // Additional fields for form functionality
  current_r: "2500",
  current_b: "2500",
  openAirTR_top_r: "",
  openAirTR_top_y0: "56.1",
  openAirTR_top_y: "56.1",
  openAirTR_top_b: "56.1",
  busbar: "Copper",
  linkType: "Rectangle",
  currentInLinks: "",
  installation: "",
  ventilation: "",
  date: "",
  time: "",
};

export const breakerTypes = [
  { value: "1", label: "ACB: Fr1_400-1250A N" },
  { value: "2", label: "ACB: Fr1_1600A N (V+V)" },
  { value: "3", label: "ACB: Fr1_1600A S (V+V)" },
  { value: "4", label: "ACB: Fr1_2000A N (V+V)" },
  { value: "5", label: "ACB: Fr1_2000A S (V+V)" },
  { value: "6", label: "ACB: Fr1_2500A S & 400-2500A H (V+V)" },
  { value: "7", label: "ACB: Fr2_400-2500A N/S (V+V)" },
  { value: "8", label: "ACB: Fr2_3200A S & 400-3200A H (V+V)" },
  { value: "9", label: "ACB: Fr2_3200A S & 400-3200A H (H+V)" },
  { value: "10", label: "ACB: Fr2_3200A S & 400-3200A H (H+H)" },
  { value: "11", label: "ACB: Fr2_4000A S/H (H+V)" },
  { value: "12", label: "ACB: Fr2_4000A S/H (V+V)" },
  { value: "13", label: "ACB: Fr3_400-4000A H/V (V+V)" },
  { value: "14", label: "ACB: Fr3_400-4000A H/V (H+V)" },
  { value: "15", label: "ACB: Fr3_5000A H/V (V+V)" },
  { value: "16", label: "ACB: Fr3_6300A H/V (V+V)" },
  { value: "17", label: "MCCB: Fr6_400A" },
  { value: "18", label: "MCCB: Fr7_630A" },
  { value: "19", label: "MCCB: Fr7_800A" }
];

export const textFieldProperties = [
  { id: "current_r", label: "R Phase Current (A)", type: "number" },
  { id: "current_y", label: "Y Phase Current (A) *", type: "number", required: true },
  { id: "current_b", label: "B Phase Current (A)", type: "number" },
  { id: "ambient", label: "Ambient Temperature (°C) *", type: "number", required: true },
  { id: "openAirTR_top_r", label: "Open Air TR (°C) - R Phase", type: "number" },
  { id: "openAirTR_top_y", label: "Open Air TR (°C) - Y Phase", type: "number" },
  { id: "openAirTR_top_b", label: "Open Air TR (°C) - B Phase", type: "number" },
  { id: "upperTempLimit", label: "Upper Temperature Limit (°C)", type: "number" },
];

export const linkMaterialOptions = [
  { value: "", label: "-- Select Material --" },
  { value: "Copper", label: "Copper" },
  { value: "Aluminium", label: "Aluminium" },
];

export const linkConfigTextFieldProperties = [
  { id: "linksPerPole", label: "Links/Cables per Pole", type: "number" },
  { id: "hotResistivity", label: "Link/Cable Hot Resistivity (Ω·m)", type: "text" },
  { id: "linkLength", label: "Link/Cable Length (m)", type: "text" },
  { id: "crossSection", label: "Link/Cable Cross Section (m²)", type: "text" },
  { id: "linkWidth", label: "Link Width (m)", type: "number" },
  { id: "linkThickness", label: "Link Thickness (m)", type: "number" },
  { id: "insulationThickness", label: "Insulation Thickness (m)", type: "number" },
  { id: "current_cl", label: "Current in Links/Cables (A)", type: "number" },
];

export const panelConfigTextFieldProperties = [
  { id: "panelHeight", label: "Panel Height (m) *", type: "number", required: true },
  { id: "panelWidth", label: "Panel Width (m) *", type: "number", required: true },
  { id: "panelDepth", label: "Panel Depth (m) *", type: "number", required: true },
  { id: "numPartitions", label: "Horizontal Partitions", type: "number" },
  { id: "links_total_length", label: "Total Length of links per pole", type: "number" },
  { id: "currentInLinks", label: "Current in Links/Cables (A)", type: "number" },
];

export const installationTypeOptions = [
  { value: "Type 1 - Separate enclosure, detached on all sides", label: "Type 1 - Separate enclosure, detached on all sides" },
  { value: "Type 2 - First or Last enclosure, detached type", label: "Type 2 - First or Last enclosure, detached type" },
  { value: "Type 3 - Separate enclosure, wall mounting", label: "Type 3 - Separate enclosure, wall mounting" },
  { value: "Type 3 - Central enclosure, detached type", label: "Type 3 - Central enclosure, detached type" },
  { value: "Type 4 - First or last enclosure wall mounting type", label: "Type 4 - First or last enclosure wall mounting type" },
  { value: "Type 5 - First or last enclosure wall mounting type", label: "Type 5 - First or last enclosure wall mounting type" },
  { value: "Type 5 - Central enclosure, wall mounting type & top surfaces covered", label: "Type 5 - Central enclosure, wall mounting type & top surfaces covered" },
];

export const ipRatingOptions = [
  { value: "IP4X", label: "IP4X" },
  { value: "IP5X", label: "IP5X" },
  { value: "Fan Cooling", label: "Fan Cooling" },
];

export const monthOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export const panelColorOptions = [
  { value: "White(metal)", label: "White(metal)" },
  { value: "Cream(metal)", label: "Cream(metal)" },
  { value: "Yellow(metal)", label: "Yellow(metal)" },
  { value: "Light:Grey,blue,green(metal)", label: "Light:Grey,blue,green(metal)" },
  { value: "Medium:Grey,blue,green(metal)", label: "Medium:Grey,blue,green(metal)" },
  { value: "Dark:Grey,blue,green(metal)", label: "Dark:Grey,blue,green(metal)" },
  { value: "Black(metal)", label: "Black(metal)" },
  { value: "Light(Plastic)", label: "Light(Plastic)" },
  { value: "Medium(Plastic)", label: "Medium(Plastic)" },
  { value: "Dark(Plastic)", label: "Dark(Plastic)" },
];

export const panelOrientationOptions = [
  { value: "South", label: "South" },
  { value: "North", label: "North" },
  { value: "East", label: "East" },
  { value: "West", label: "West" },
];